import { BaseController } from "../../common/base/controller";
import { statusVerifyStateName } from "./verify/verify.state";
import { PROGRESS_STATES } from "./status.constants";
import moment from "moment";

export class StatusController extends BaseController {
	dateFormat = "dd.MM.yyyy";

	progressbarStates = PROGRESS_STATES;
	progressState = "app.status.started";

	showConfirmationButton = false;

	constructor(
		$location,
		configService,
		controllerService,
		errorTrackingService,
		statusService,
	) {
		"ngInject";
		super({
			$location,
			configService,
			controllerService,
			errorTrackingService,
			statusService,
		});
	}

	set orderId(orderId) {
		this.appCache.set("orderId", orderId);
	}

	get orderId() {
		const params = this.$location.search();
		const { orderId } = this.$stateParams;
		return this.appCache.get("orderId") || params.id || orderId;
	}

	get documentLink() {
		return `${this.statusService.api}/letters/${this.documentId}?jwt=${this.documentToken}`;
	}

	get hasOldOwner() {
		return this.oldOwners && this.oldOwners[0].firstName;
	}

	get markedAfterDays() {
		return moment().diff(moment(this.submissionTimestamp), "days");
	}

	get tenantName() {
		return this.configService.getName();
	}

	get deadlineLimit() {
		return this.configService.getFeature(this.Features.switchDeadlineInDays);
	}

	$onInit() {
		this.setupValidation();
		this.loadStatus();
	}

	downloadPackage() {
		this.$window.open(this.documentLink, "_blank");
	}

	determineProgressState() {
		if (this.documentId) {
			this.progressState = "app.status.transmitted";
		}

		if (this.submissionTimestamp) {
			this.progressbarStates[0].translateParams = {
				submissionTimestamp: moment(this.submissionTimestamp).format(
					"DD.MM.yyyy",
				),
			};
		}

		if (this.shipmentStatus.shipmentDone) {
			this.progressState = "app.status.shipped";
			this.progressbarStates[2].stepTitleKey = "app.status.shipped";
			this.progressbarStates[2].translateParams = {
				shipmentTimestamp: moment(this.shipmentStatus.shipmentTimestamp).format(
					"DD.MM.yyyy",
				),
			};
		}
	}

	setupValidation() {
		const params = this.$location.search();

		if (params.id) {
			// Read the orderId from the URL
			this.orderId = params.id;
		}

		const maybeCachedBirthdate = this.appCache.get("birthDate");

		if (maybeCachedBirthdate) {
			this.birthDate = maybeCachedBirthdate;
			this.appCache.remove("birthDate");
		}

		if (params.birthDate) {
			// Read the token from the URL and format it as a date
			this.birthDate = params.birthDate;
		}
	}

	loadStatus(inBackground = false) {
		this.loading = !inBackground;

		this.statusService.getStatus(this.orderId, this.birthDate).then(
			(resp) => {
				this.oldPortfolio = resp.options;
				this.newOwners = resp.owners;
				this.oldOwners = resp.previousOwners;
				this.documentId = resp.documentId;
				this.documentToken = resp.documentToken;
				this.oldBank = {
					...resp.oldBank,
					oldAccountNumber: resp.sourceAccount,
					shortName: resp.oldBank && resp.oldBank.name,
				};
				this.newBank = {
					...resp.newBank,
					newAccountNumber: resp.destinationAccount,
					shortName: this.tenantName,
				};
				this.submissionTimestamp = resp.submissionTimestamp;

				this.shipmentStatus = {
					shipmentFailed: resp.shipmentFailed,
					shipmentDone: resp.shipmentDone,
					shipmentTimestamp: resp.shipmentTimestamp,
				};

				// NOTE: Due to confusion, we are no longer displaying the confirmation button
				// this.showConfirmationButton = resp.showConfirmationButton;

				// we need order id and dates, since we have an asynchronous process in api it is
				// not directly present, show loading spinner and try again a few seconds later
				if (!this.minimalInfosPresent()) {
					this.$timeout(() => this.loadStatus(), 2000);
					return;
				}

				this.loading = false;
				this.determineProgressState();

				const deadline = new Date(this.oldPortfolio.deadline);
				const today = new Date();

				const remainingDays =
					this.deadlineLimit -
					Math.round((today - deadline) / (1000 * 60 * 60 * 24));

				this.value = remainingDays;

				// Calculate the progress by the percentage of the remaining days of the 21 day period
				this.progress = Math.round((remainingDays / this.deadlineLimit) * 100);
				this.timelimitExceeded = remainingDays <= 0;

				// Track event for status page
				this.trackingService.trackEvent("status-loaded", {
					category: "status",
					label: "request",
				});

				// fetch until documents are present
				if (!this.documentId) {
					this.$timeout(() => this.loadStatus(true), 4000);
				}
			},
			(error) => {
				const { status } = error;
				if (status === 403) {
					this.go(statusVerifyStateName, {
						invalidbirthDate: this.birthDate,
						orderId: this.orderId,
					});
					return;
				}
				if (status === 404) {
					this.$timeout(() => this.loadStatus(), 4000);
				}
			},
		);
	}

	minimalInfosPresent() {
		return this.submissionTimestamp;
	}

	markStatusAsCompleted() {
		this.statusCompletionLoading = true;
		this.statusService
			.markStatusAsCompleted(this.orderId, this.birthDate)
			.then(() => {
				this.completedDWS = true;
			})
			.finally(() => {
				this.statusCompletionLoading = false;
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/status/status.controller.js